import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import styles from './MembershipPeriodField.scss';
import {FormField} from 'components/controls';
import intervalList, {chooseIntervalList, CUSTOM, DAY} from 'sources/constants/intervalTypes';
import TextField from './TextField';
import DropDownList from './DropDownList';
import maxIntervalsCount from 'sources/constants/maxIntervalCounts';

export default class MembershipPeriodField extends PureComponent {
    static propTypes = {
        label: PropTypes.string,
        error: PropTypes.string,
        onChange: PropTypes.func,
        interval: PropTypes.string,
        intervalCount: PropTypes.number,
        isRenewableMembership: PropTypes.bool,
    };

    static defaultProps = {
        label: '',
        error: null,
        onChange: null,
        interval: DAY,
        intervalCount: 1,
    };

    state = {
        chosenInterval: DAY,
    };

    chosenIntervalFormatter = (value) => {
        return loc(`choose-${value}`);
    };

    intervalFormatter = (value) => {
        return loc(`plural-${value}`);
    };

    handleChangeValue = (interval, intervalCount) => {
        const {onChange} = this.props;

        const value = {
            interval,
            intervalCount,
        };

        onChange({target: {value}});
    };

    handleChangeChooseInterval = ({target: {value}}) => {
        this.setState({chosenInterval: value, intervalCount: 1});
        if (value === CUSTOM) {
            this.handleChangeValue(DAY, 1);
        }

        this.handleChangeValue(value, 1);
    };

    handleChange = (fieldName) => ({target: {value}}) => {
        if (fieldName === 'intervalCount') {
            const {interval} = this.props;
            this.handleChangeValue(interval, value);

            return;
        }
        const {intervalCount} = this.props;
        this.handleChangeValue(value, intervalCount)
    };

    render() {
        const {chosenInterval} = this.state;
        const {label, error, intervalCount, interval, isRenewableMembership} = this.props;
        const customFieldsOpened = chosenInterval === CUSTOM;

        return (
            <FormField
                label={label}
                error={error}
            >
                <div
                    className={styles.fieldWrapper}
                >
                    <DropDownList
                        items={chooseIntervalList}
                        value={chosenInterval}
                        formatter={this.chosenIntervalFormatter}
                        onChange={this.handleChangeChooseInterval}
                        customClassName={styles.intervalField}
                    />
                    {customFieldsOpened &&
                    <div className={styles.customFieldWrapper}>
                        <TextField
                            type='number'
                            value={intervalCount}
                            error={error}
                            min={0}
                            max={isRenewableMembership && maxIntervalsCount[interval]}
                            onChange={this.handleChange('intervalCount')}
                        />
                        <DropDownList
                            items={intervalList}
                            value={interval}
                            formatter={this.intervalFormatter}
                            onChange={this.handleChange('interval')}
                        />
                    </div>}
                </div>
            </FormField>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/controls/MembershipPeriodField.jsx